import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import {
  ITEM_REPORT_TYPE_NOT_WORKING,
  ITEM_REPORT_TYPE_SPAM,
  ITEM_REPORT_TYPE_PAYWALL,
} from './itemsActions'





const ItemReportOptions = ({
  currentReport,
  onNotWorkingClick,
  onSpamClick,
  onPaywallClick,
  onReportNeutralClick,
  onClose,
}) => {

  const handleButtonClick = useCallback((callback) => (e) => {
    onClose()
    callback()
  }, [onClose])

  // Set the active state of the report options
  const reportStatus = useMemo(() => ({
    notWorkingActive: currentReport === ITEM_REPORT_TYPE_NOT_WORKING,
    spamActive: currentReport === ITEM_REPORT_TYPE_SPAM,
    paywallActive: currentReport === ITEM_REPORT_TYPE_PAYWALL,
  }), [currentReport])

  const getColor = (isActive) => isActive ? '#ff0000' : '#777777'

  return (
    <span className='item-report-options-wrapper'>
      <span className='item-report-options-header'>Ilmianna</span>
      <span className='item-report-options'>
        <button type='button' className='item-report-option gtm-item-vote' onClick={ handleButtonClick(reportStatus.spamActive ? onReportNeutralClick : onSpamClick) }>
          <span className='item-report'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 122.88 118.3'
              width={ 20 }
            >
              <g>
                <path
                  fillRule='evenodd' clipRule='evenodd' fill={ getColor(reportStatus.spamActive) } d='M7.51,0h107.85c2.05,0,3.93,0.85,5.29,2.21v0l0.01,0.01l0.01,0.01l0.01,0.01c1.36,1.37,2.2,3.24,2.2,5.29 v103.28c0,2.07-0.85,3.95-2.21,5.31c-1.36,1.36-3.24,2.21-5.31,2.21H7.51c-2.05,0-3.93-0.84-5.3-2.21l-0.01-0.01l-0.01-0.01 l-0.01-0.01c-1.36-1.37-2.2-3.24-2.2-5.29V7.51C0,5.44,0.84,3.56,2.2,2.2c0.08-0.08,0.16-0.16,0.25-0.23C3.79,0.75,5.57,0,7.51,0 L7.51,0z M17.59,34.77h85.94v33.65H17.59V34.77L17.59,34.77z M44.08,58.63h-6.43l-0.92,3.46h-5.8l6.92-20.98h6.21l6.89,20.98H45 L44.08,58.63L44.08,58.63z M42.88,54.09l-2.01-7.54l-2.01,7.54H42.88L42.88,54.09z M53.72,41.11h8.44c1.66,0,3.01,0.26,4.03,0.77 c1.02,0.52,1.87,1.26,2.54,2.22c0.67,0.97,1.15,2.09,1.45,3.36c0.3,1.28,0.45,2.63,0.45,4.06c0,2.24-0.22,3.98-0.67,5.21 c-0.44,1.24-1.06,2.27-1.86,3.11c-0.8,0.84-1.65,1.39-2.56,1.67c-1.24,0.38-2.37,0.57-3.38,0.57h-8.44V41.11L53.72,41.11z M59.39,45.85v11.46h1.39c1.19,0,2.04-0.15,2.54-0.45c0.5-0.3,0.89-0.83,1.18-1.57c0.29-0.75,0.43-1.96,0.43-3.64 c0-2.22-0.32-3.74-0.95-4.56c-0.64-0.82-1.69-1.23-3.17-1.23H59.39L59.39,45.85z M73.53,55.15l5.39-0.39 c0.12,1,0.35,1.76,0.71,2.28c0.59,0.84,1.42,1.27,2.51,1.27c0.81,0,1.43-0.21,1.87-0.65c0.44-0.43,0.66-0.94,0.66-1.51 c0-0.54-0.2-1.03-0.62-1.46c-0.41-0.43-1.38-0.83-2.9-1.22c-2.49-0.63-4.26-1.48-5.32-2.54c-1.07-1.05-1.6-2.4-1.6-4.04 c0-1.07,0.27-2.09,0.82-3.05c0.55-0.96,1.37-1.71,2.47-2.26c1.1-0.55,2.6-0.82,4.52-0.82c2.35,0,4.14,0.5,5.37,1.5 c1.23,1,1.96,2.58,2.2,4.76l-5.34,0.36c-0.14-0.95-0.44-1.65-0.89-2.08c-0.46-0.43-1.09-0.65-1.89-0.65 c-0.66,0-1.16,0.16-1.49,0.48c-0.33,0.32-0.5,0.71-0.5,1.17c0,0.33,0.14,0.63,0.41,0.9c0.26,0.28,0.89,0.53,1.89,0.77 c2.48,0.61,4.26,1.23,5.32,1.86c1.07,0.63,1.86,1.4,2.34,2.32c0.49,0.92,0.73,1.96,0.73,3.11c0,1.34-0.33,2.58-0.98,3.72 c-0.65,1.13-1.56,2-2.73,2.58c-1.17,0.59-2.64,0.88-4.42,0.88c-3.12,0-5.29-0.69-6.49-2.06C74.37,59,73.69,57.26,73.53,55.15 L73.53,55.15z M18.14,84.39c-1.29,0-2.34-1.05-2.34-2.34c0-1.29,1.05-2.34,2.34-2.34h35.74c1.29,0,2.34,1.05,2.34,2.34 c0,1.29-1.05,2.34-2.34,2.34H18.14L18.14,84.39z M64.13,84.39c-1.3,0-2.35-1.05-2.35-2.35c0-1.3,1.05-2.35,2.35-2.35h38.55 c1.3,0,2.35,1.05,2.35,2.35c0,1.3-1.05,2.35-2.35,2.35H64.13L64.13,84.39z M64.13,97.99c-1.3,0-2.35-1.05-2.35-2.35 s1.05-2.35,2.35-2.35h38.55c1.3,0,2.35,1.05,2.35,2.35s-1.05,2.35-2.35,2.35H64.13L64.13,97.99z M19.27,97.98 c-1.29,0-2.34-1.05-2.34-2.34c0-1.29,1.05-2.34,2.34-2.34h35.74c1.29,0,2.34,1.05,2.34,2.34c0,1.29-1.05,2.34-2.34,2.34H19.27 L19.27,97.98z M50.12,9.7c2.7,0,4.88,2.19,4.88,4.88s-2.19,4.88-4.88,4.88s-4.88-2.19-4.88-4.88S47.43,9.7,50.12,9.7L50.12,9.7z M15.99,9.7c2.7,0,4.88,2.19,4.88,4.88s-2.19,4.88-4.88,4.88c-2.7,0-4.88-2.19-4.88-4.88S13.29,9.7,15.99,9.7L15.99,9.7z M33.05,9.7c2.7,0,4.88,2.19,4.88,4.88s-2.19,4.88-4.88,4.88c-2.7,0-4.88-2.19-4.88-4.88S30.36,9.7,33.05,9.7L33.05,9.7z M116.09,26.93c-0.24,0.04-0.48,0.06-0.72,0.06H7.51c-0.25,0-0.49-0.02-0.72-0.06v83.86c0,0.2,0.08,0.38,0.2,0.51l0,0l0.01,0.01 c0.13,0.13,0.3,0.2,0.51,0.2h107.85c0.19,0,0.37-0.08,0.51-0.22c0.13-0.13,0.22-0.31,0.22-0.51V26.93L116.09,26.93z'
                />
              </g>
            </svg>
          </span>
          <span className='item-report-option-label' id='mainos'>Mainos</span>
        </button>

        <button type='button' className='item-report-option gtm-item-vote' onClick={ handleButtonClick(reportStatus.paywallActive ? onReportNeutralClick : onPaywallClick) }>
          <span className='item-report'>
            <svg
              viewBox='0 0 300 300.621'
              xmlns='http://www.w3.org/2000/svg'
              width={ 24 }
            >
              <path fill={ getColor(reportStatus.paywallActive) } d='M175 75.12a89.625 89.625 0 0 0-12.5 1A56.125 56.125 0 0 0 50 81.37v6.25a25 25 0 0 0-25 25v112.5a24.25 24.25 0 0 0 25 25h59.125A100 100 0 1 0 175 75.12zM75 81.37a31.375 31.375 0 0 1 62.5-3v9.25H75zm100 168.75a75 75 0 1 1 75-75 75 75 0 0 1-75 75zm-18.75-100v12.5h50a12.5 12.5 0 0 1 12.5 12.5v37.5a12.5 12.5 0 0 1-12.5 12.5H187.5v12.5h-25v-12.5h-31.25v-25h62.5v-12.5h-50a12.5 12.5 0 0 1-12.5-12.5v-37.5a12.5 12.5 0 0 1 12.5-12.5h18.75v-12.5h25v12.5h31.25v25z' />
            </svg>
          </span>
          <span className='item-report-option-label' id='maksumuuri'>Maksumuuri</span>
        </button>

        <button type='button' className='item-report-option gtm-item-vote' onClick={ handleButtonClick(reportStatus.notWorkingActive ? onReportNeutralClick : onNotWorkingClick) }>
          <span className='item-report'>
            <svg viewBox='0 0 1664 1664' width={ 20 }>
              <path fill={ getColor(reportStatus.notWorkingActive) } d='m439 1271l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23m169 41v320q0 14-9 23t-23 9t-23-9t-9-23v-320q0-14 9-23t23-9t23 9t9 23m-224-224q0 14-9 23t-23 9H32q-14 0-23-9t-9-23t9-23t23-9h320q14 0 23 9t9 23m1264 128q0 120-85 203l-147 146q-83 83-203 83q-121 0-204-85l-334-335q-21-21-42-56l239-18l273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67q0-40-28-68l-274-275l18-239q35 21 56 42l336 336q84 86 84 204m-617-724l-239 18l-273-274q-28-28-68-28q-39 0-68 27L236 381q-28 28-28 67q0 40 28 68l274 274l-18 240q-35-21-56-42L100 652q-84-86-84-204q0-120 85-203L248 99q83-83 203-83q121 0 204 85l334 335q21 21 42 56m633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23t9-23t23-9h320q14 0 23 9t9 23M1120 32v320q0 14-9 23t-23 9t-23-9t-9-23V32q0-14 9-23t23-9t23 9t9 23m407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23' />
            </svg>
          </span>

          <span className='item-report-option-label' id='linkki-rikki'>Linkki rikki</span>
        </button>
      </span>
    </span>
  )
}

ItemReportOptions.propTypes = exact({
  currentReport: PropTypes.string.isRequired,
  onNotWorkingClick: PropTypes.func.isRequired,
  onSpamClick: PropTypes.func.isRequired,
  onPaywallClick: PropTypes.func.isRequired,
  onReportNeutralClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
})

export default ItemReportOptions
